import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  NgZone,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TextContentService } from '@core/text-content/text-content.service';
import { Observable } from 'rxjs';

import {
  FlightTrackerHttpErrorResponse,
  FlightTrackerResultMessage,
} from '../flight-tracker.type';
import { FlightTrackerCopy } from '../types/flight-tracker-copy.type';
import { FlightTrackerFlight } from '../types/flight-tracker-result.type';
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'jb-flight-tracker-results',
  templateUrl: './flight-tracker-results.component.html',
  styleUrls: ['./flight-tracker-results.component.scss'],
  providers: [],
  animations: [
    trigger('headerAnim', [
      state(
        'false',
        style({
          opacity: '1',
          display: 'block',
        }),
      ),
      state(
        'true',
        style({
          opacity: '0',
          display: 'none',
        }),
      ),
      transition('* <=> *', animate('150ms')),
    ]),
  ],
})
export class FlightTrackerResultsComponent
  implements AfterViewInit, OnChanges, OnInit
{
  private _destroy = inject(DestroyRef);

  currentTime = new Date();
  hideHeader = false;
  isWrappedDirect = false;
  isWrappedConnecting = false;
  @Input('flightTrackerDirectResults')
  flightTrackerDirectResults: FlightTrackerFlight[] | undefined;
  @Input('flightTrackerConnectingResults')
  flightTrackerConnectingResults: FlightTrackerFlight[] | undefined;
  @Input() flightTrackerError: FlightTrackerHttpErrorResponse;
  @Input() noResultsError: FlightTrackerResultMessage;
  @Input() serviceError: FlightTrackerResultMessage;

  @Input() departureDate;
  @Output() refreshStatus = new EventEmitter();
  @ViewChild('serverError', { read: ElementRef })
  serverError;
  @ViewChild('serverErrorOffline', { read: ElementRef })
  serverErrorOffline;
  @ViewChild('flightResultsContainer', { read: ElementRef })
  flightResultsContainer;

  flightTrackerText$: Observable<FlightTrackerCopy>;

  constructor(
    private zone: NgZone,
    private textContentService: TextContentService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.flightTrackerText$ = this.textContentService
      .getJsonAsset('flight-tracker')
      .pipe(takeUntilDestroyed(this._destroy));
  }

  ngAfterViewInit() {
    if (this.flightTrackerError?.error) {
      this.serverError.nativeElement.focus();
    } else if (!!this.flightTrackerDirectResults) {
      this.zone.runOutsideAngular(() =>
        setTimeout(() => this.flightResultsContainer.nativeElement.focus()),
      );
    } else if (this.flightTrackerDirectResults === undefined) {
      this.serverErrorOffline.nativeElement.focus();
    }
  }

  ngOnChanges() {
    // When polling is turned on, we update time on every interval
    this.currentTime = new Date();
  }

  displayHeader($event) {
    this.hideHeader = $event;
  }

  handleWrapDetection(isWrapped: boolean, flightType: string) {
    if (flightType === 'direct') {
      this.isWrappedDirect = isWrapped;
    } else if (flightType === 'connecting') {
      this.isWrappedConnecting = isWrapped;
    }
    this.cdr.detectChanges();
  }
}
